import { render, staticRenderFns } from "./serv.vue?vue&type=template&id=4c434de0&scoped=true"
import script from "./serv.vue?vue&type=script&lang=js"
export * from "./serv.vue?vue&type=script&lang=js"
import style0 from "./serv.vue?vue&type=style&index=0&id=4c434de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c434de0",
  null
  
)

export default component.exports